import { render, staticRenderFns } from "./inquiry-opinion.vue?vue&type=template&id=ed8b4314&scoped=true"
import script from "./inquiry-opinion.vue?vue&type=script&lang=js"
export * from "./inquiry-opinion.vue?vue&type=script&lang=js"
import style0 from "./inquiry-opinion.vue?vue&type=style&index=0&id=ed8b4314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8b4314",
  null
  
)

export default component.exports